import { message } from "antd";
import { showError, showSuccess } from "common/ToastNotifications";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import { MessageBox } from "components/atoms/MessageBox";
import OkCancelConfirmationBox from "components/molecules/OkCancelConfirmationBox";
import ProhibitedArea from "components/molecules/ProhibitedArea";
import DataTagList from "components/organisms/DataTagList";
import ManageDataTag from "components/organisms/ManageDataTag";
import AppPaths from "constants/appPaths";
import flatten from "flat";
import _ from "lodash";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";
import DataTagAudit from "./DataTagAudit";

class DataTags extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingPermission: true,
            isGeneratingTags: false,
            isCreatingTags: false,
            isRephrasingTags: false,
        };
    }
    componentDidMount() {
        // Load initial data and set view state if needed
        const savedViewState = localStorage.getItem("viewState");
        if (savedViewState && savedViewState !== this.props.viewState) {
            this.props.setViewState(savedViewState);
        }
        if (!this.props.keyExists && !this.props.checkedKeys) {
            this.getKeyByTypeExists();
            this.setState({ hasCheckedForKey: true });
        }
    }

    componentWillMount() {
        this.showBreadCrumbNavigationItems();
        this.props.getUserDataTagPermission();
        if (!this.props.action) {
            this.setState({
                busy: true,
                busyMessage: "Getting Data Tags...",
                fetchingDataTags: true,
            });
            this.props.getDataTags();
        } else {
            this.props.getUserBusinessAreas();
            if (this.props.tagId) {
                this.props.getDataTagById(this.props.tagId);
            }
            if (this.props.action === "view" || this.props.action === "edit") {
                this.setState({
                    busy: true,
                    busyMessage: "Getting Data Tag...",
                    fetchingDataTag: true,
                });
            } else if (this.props.action === "history") {
                this.setState({
                    showHistory: false,
                    busy: true,
                    fetchingDataTag: true,
                });
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetDataTagsResultUpdate(prevProps);

        this.onCreateDataTagResultUpdate(prevProps);

        this.onGetDataTagByIdResultUpdate(prevProps);

        this.onUpdateDataTagResultUpdate(prevProps);

        this.onDeleteDataTagResultUpdate(prevProps);

        this.onGetUserDataTagPermissionResultUpdate(prevProps);

        this.onReorderDataTagsResultUpdate(prevProps);

        this.onMultiDeleteDataTagsResultUpdate(prevProps);

        this.onBulkCreateDataTagResultUpdate(prevProps);

        this.onAiGenerateDataTagResultUpdate(prevProps);

        this.onGetKeyByTypeExistsResultUpdate(prevProps);

        this.onRephraseDataTagResultUpdate(prevProps);

        this.onAiGenerateDescriptionResultUpdate(prevProps);

        this.onBulkMoveDataTagsResultUpdate(prevProps);
    }

    onGetDataTagsResultUpdate = (prevProps) => {
        if (this.props.getDataTagsResult && this.props.getDataTagsResult !== prevProps.getDataTagsResult) {
            if (!this.props.getDataTagsResult.success) {
                if (this.props.getDataTagsResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get data tag at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingDataTags: false,
            });
        }
    };

    onReorderDataTagsResultUpdate = (prevProps) => {
        if (this.props.reorderResult && this.props.reorderResult !== prevProps.reorderResult) {
            if (!this.props.reorderResult.success) {
                message.error(this.props.reorderResult.message || "Reordering data tags failed! Please try again.");
            } else {
                message.success("Data tags reordered successfully! Synced with the server.");
            }
            this.setState({
                busy: false,
            });
        }
    };

    onCreateDataTagResultUpdate = (prevProps) => {
        if (this.props.createDataTagResult && this.props.createDataTagResult !== prevProps.createDataTagResult) {
            if (!this.props.createDataTagResult.success) {
                showError(this.props.createDataTagResult.message || "Data tag cannot be created.");
                this.setState({
                    busy: false,
                    manageDataTagErrors: this.props.createDataTagResult.fields,
                });
            } else {
                this.setState({
                    busy: true,
                    busyMessage: "Data tag created. Please wait...",
                });
                showSuccess("Data tag created successfully.", () => {
                    this.cancelManageDataTag();
                });
            }
        }
    };

    onGetDataTagByIdResultUpdate = (prevProps) => {
        if (this.props.getDataTagByIdResult && this.props.getDataTagByIdResult !== prevProps.getDataTagByIdResult) {
            if (!this.props.getDataTagByIdResult.success) {
                if (this.props.getDataTagByIdResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get data tag.");
                }
            } else if (this.props.action === "history") {
                this.setState({
                    showHistory: true,
                });
            }
            this.setState({
                busy: false,
                fetchingDataTag: false,
            });
            if (!this.props.dataTagsResult || !this.props.dataTagsResult.Items || this.props.dataTagsResult.Items.length === 0) {
                this.showBreadCrumbNavigationItems();
            }
        }
    };

    onUpdateDataTagResultUpdate = (prevProps) => {
        if (this.props.updateDataTagResult && this.props.updateDataTagResult !== prevProps.updateDataTagResult) {
            if (!this.props.updateDataTagResult.success) {
                showError(this.props.updateDataTagResult.message || "Data tag cannot be updated.");
                this.setState({
                    busy: false,
                    manageDataTagErrors: this.props.updateDataTagResult.fields,
                });
            } else {
                this.setState({
                    busy: true,
                    busyMessage: "Data tag updated. Please wait...",
                });
                showSuccess("Data tag updated successfully.", () => {
                    this.cancelManageDataTag();
                });
            }
        }
    };

    onDeleteDataTagResultUpdate = (prevProps) => {
        if (this.props.deleteDataTagResult && this.props.deleteDataTagResult !== prevProps.deleteDataTagResult) {
            if (!this.props.deleteDataTagResult.success) {
                showError(this.props.deleteDataTagResult.message || "Data tag cannot be deleted.");
            } else {
                showSuccess("Data tag deleted successfully.");
            }
            this.setState({
                busy: false,
            });
        }
    };

    onMultiDeleteDataTagsResultUpdate = (prevProps) => {
        if (this.props.multiDeleteDataTagsResult && this.props.multiDeleteDataTagsResult !== prevProps.multiDeleteDataTagsResult) {
            if (!this.props.multiDeleteDataTagsResult.success) {
                showError(this.props.multiDeleteDataTagsResult.message || "Data tags cannot be deleted.");
            } else {
                showSuccess("Data tags deleted successfully.");
            }
            this.setState({
                busy: false,
            });
        }
    };

    onBulkCreateDataTagResultUpdate = (prevProps) => {
        if (this.props.bulkCreateDataTagResult && this.props.bulkCreateDataTagResult !== prevProps.bulkCreateDataTagResult) {
            // console.log("bulkCreateDataTagResult",this.props.bulkCreateDataTagResult);
            if (this.props.bulkCreateDataTagResult.success === null) {
                return;
            }
            if (!this.props.bulkCreateDataTagResult.success) {
                let errorMessage = "Bulk create data tags failed.";
                // Removed debug console.log to avoid leaking debug output in production.

                // In bulk create data tags there can be multiple errors in a single request, so we need to handle them accordingly.
                // If the error code is INVALID_REQUEST_BODY, we will show the field errors.

                if (this.props.bulkCreateDataTagResult.code === "INVALID_REQUEST_BODY") {
                    const fieldErrors = Object.values(this.props.bulkCreateDataTagResult.fields);
                    const uniqueErrors = [...new Set(fieldErrors)];
                    const errorCount = Object.keys(this.props.bulkCreateDataTagResult.fields).length;
                    errorMessage = `${uniqueErrors.join(". ")} (${errorCount} tag${errorCount > 1 ? "s" : ""} affected)`;
                } else if (this.props.bulkCreateDataTagResult.message && this.props.bulkCreateDataTagResult.code !== "INVALID_REQUEST_BODY") {
                    errorMessage = this.props.bulkCreateDataTagResult.message;
                }

                showError(errorMessage);
            } else {
                showSuccess("Bulk create data tags successful.");
                setTimeout(() => {
                    this.cancelManageDataTag();
                }, 1000);
            }
            this.setState({
                isCreatingTags: false,
            });
        }
    };

    onAiGenerateDataTagResultUpdate = (prevProps) => {
        if (this.props.aiGenerateDataTagResult && this.props.aiGenerateDataTagResult !== prevProps.aiGenerateDataTagResult) {
            // console.log("aiGenerateDataTagResult",this.props.aiGenerateDataTagResult);
            if (this.props.aiGenerateDataTagResult.success === null) {
                return; // No result yet, do nothing
            }
            if (!this.props.aiGenerateDataTagResult.success) {
                showError(this.props.aiGenerateDataTagResult.message || "AI generate data tags failed.");
            } else {
                showSuccess("Data tags generated by AI successfully.");
            }
            this.setState({
                isGeneratingTags: false,
            });
            // console.log("ai geernated tags",this.props.aiGeneratedTags);
        }
    };

    onAiGenerateDescriptionResultUpdate = (prevProps) => {
        if (this.props.aiGenerateDescriptionResult && this.props.aiGenerateDescriptionResult !== prevProps.aiGenerateDescriptionResult) {
            if (!this.props.aiGenerateDescriptionResult.success) {
                showError(this.props.aiGenerateDescriptionResult.message || "AI generate description failed.");
            } else {
                showSuccess("AI generated description successfully.");
            }
            this.setState({
                busy: false,
            });
        }
    };

    onRephraseDataTagResultUpdate = (prevProps) => {
        if (this.props.rephraseDataTagResult && this.props.rephraseDataTagResult !== prevProps.rephraseDataTagResult) {
            // console.log("rephraseDataTagResult",this.props.rephraseDataTagResult);
            if (this.props.rephraseDataTagResult.success === null) {
                return; // No result yet, do nothing
            }
            if (!this.props.rephraseDataTagResult.success) {
                showError(this.props.rephraseDataTagResult.message || "Rephrasing data tag failed.");
            } else {
                showSuccess("Data tags rephrased successfully.");
            }
            this.setState({
                isRephrasingTags: false,
            });
        }
    };
    onBulkMoveDataTagsResultUpdate = (prevProps) => {
        if (this.props.bulkUpdateDataTagResult && this.props.bulkUpdateDataTagResult !== prevProps.bulkUpdateDataTagResult) {
            if (!this.props.bulkUpdateDataTagResult.success) {
                showError(this.props.bulkUpdateDataTagResult.message || "Could not move tags to the selected business area.");
            } else {
                showSuccess("Tags moved to the selected business area successfully.");
                this.props.getDataTags();
            }
            this.setState({
                busy: false,
            });
        }
    };
    onGetKeyByTypeExistsResultUpdate = (prevProps) => {
        if (this.props.getKeyByTypeExistsResult && this.props.getKeyByTypeExistsResult !== prevProps.getKeyByTypeExistsResult) {
            if (this.props.checkedKeys && !this.props.keyExists) {
                showError("OPEN_AI_KEY is not configured. Please add it in the system keys.");
            } else {
                this.setState({
                    permissionDenied: false,
                });
            }
        }
    };

    onGetUserDataTagPermissionResultUpdate = (prevProps) => {
        if (this.props.getUserDataTagPermissionResult && this.props.getUserDataTagPermissionResult !== prevProps.getUserDataTagPermissionResult) {
            if (!this.props.getUserDataTagPermissionResult.success) {
                this.setState({
                    permissionDenied: true,
                    fetchingPermission: false,
                });
            } else {
                this.setState({
                    fetchingPermission: false,
                });
            }
        }
    };

    showBreadCrumbNavigationItems = () => {
        if (this.props.showSubBreadCrumbNavigationItems) {
            let breadCrumbItems = [
                {
                    route: AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant.toLowerCase()).replace(
                        ":configurationItem",
                        this.props.match.params.configurationItem.toLowerCase(),
                    ),
                    text: "Data Tag",
                },
            ];
            if (this.props.action) {
                let dataTagName = "";
                switch (this.props.action.toLowerCase()) {
                    case "create":
                        breadCrumbItems.push({
                            route: "",
                            text: "New Data Tag",
                        });
                        break;
                    case "view":
                    case "edit":
                        dataTagName = this.getDataTagName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: dataTagName,
                                },
                            ],
                        );
                        break;
                    case "history":
                        dataTagName = this.getDataTagName();
                        breadCrumbItems.push(
                            ...[
                                {
                                    route: "",
                                    text: dataTagName,
                                },
                                {
                                    route: "",
                                    text: "History",
                                },
                            ],
                        );
                        break;
                    default:
                        break;
                }
            }

            this.props.showSubBreadCrumbNavigationItems(breadCrumbItems);
        }
    };

    getDataTagName = () => {
        let dataTagName = this.props.tagId;
        if (this.props.dataTagsResult && this.props.dataTagsResult.Items && this.props.dataTagsResult.Items.length > 0) {
            let dataTag = this.props.dataTagsResult.Items.find((dataTag) => dataTag.tagId === this.props.tagId);
            if (dataTag) {
                dataTagName = dataTag.tagName;
            }
        } else if (this.props.dataTag && this.props.dataTag.tagId === this.props.tagId) {
            dataTagName = this.props.dataTag.tagName;
        }
        return dataTagName;
    };

    showCreateDataTag = () => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":itemAction", "create"),
        );
    };

    showViewDataTag = (tagId) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":itemId", tagId)
                .replace(":itemAction", "view"),
        );
    };

    showEditDataTag = (tagId) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":itemId", tagId)
                .replace(":itemAction", "edit"),
        );
    };

    showDataTagHistory = (tagId) => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM_ID_ACTION.replace(":tenant", this.props.match.params.tenant)
                .replace(":configurationItem", this.props.match.params.configurationItem.toLowerCase())
                .replace(":itemId", tagId)
                .replace(":itemAction", "history"),
        );
    };

    cancelManageDataTag = () => {
        this.props.history.push(
            AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", this.props.match.params.tenant).replace(
                ":configurationItem",
                this.props.match.params.configurationItem.toLowerCase(),
            ),
        );
    };

    createDataTag = (dataTag) => {
        this.setState({
            busy: true,
            busyMessage: "Creating data tag",
        });
        this.props.createDataTag(dataTag);
    };
    bulkCreateDataTag = (dataTag) => {
        this.setState({
            isCreatingTags: true,
        });
        this.props.bulkCreateDataTag(dataTag);
    };
    aiGenerateDataTag = (dataTag) => {
        this.setState({
            isGeneratingTags: true,
        });
        this.props.aiGenerateDataTag(dataTag);
    };
    bulkMoveDataTags = (tagIds, targetBusinessAreaId) => {
        this.setState({
            busy: true,
            busyMessage: "Moving Selected data tags to new business Area...",
        });
        const dataTagsToUpdate = tagIds
            .map((tagId) => {
                const tag = this.props.dataTagsResult.Items.find((t) => t.tagId === tagId);
                if (!tag) {
                    message.warning(`Data tag with id ${tagId} not found!`);
                    return null;
                }
                if (tag.businessAreaId === targetBusinessAreaId) {
                    message.info(`Data tag '${tag.tagName}' is already in the selected business area.`);
                    return null;
                }
                return {
                    tagId: tagId,
                    businessAreaId: targetBusinessAreaId,
                    tagName: tag.tagName,
                    version: tag.version,
                };
            })
            .filter((tag) => tag !== null);
        this.props.bulkUpdateDataTag(dataTagsToUpdate);
    };

    rephraseDataTag = (dataTag) => {
        this.setState({
            isRephrasingTags: true,
        });
        this.props.rephraseDataTag(dataTag);
    };

    getKeyByTypeExists = () => {
        this.props.getKeyByTypeExists("OPEN_AI_KEY");
    };

    resetGeneratedTags = () => {
        this.props.resetAiGeneratedTags();
    };

    aiGenerateDescription = (dataTag) => {
        this.setState({
            busy: true,
            busyMessage: "Generating description...",
        });
        this.props.aiGenerateDescription(dataTag);
    };

    updateDataTag = (dataTag, updatedDataTag) => {
        this.setState({
            busy: true,
            busyMessage: "Updating data tag...",
        });
        this.props.updateDataTag(dataTag, updatedDataTag);
    };
    handleTagReorder = (datatag) => {
        this.props.dndTags(datatag);
        const tags = Array.isArray(datatag) ? datatag : [datatag];
        if (!this.props.isUpdating) {
            const dataTags = tags.map((tag) => ({
                tagId: tag.tagId,
                oldSortOrder: tag.oldSortOrder,
                sortOrder: tag.sortOrder,
            }));
            this.props.reorderDataTags(dataTags);
        }
    };
    showMultiDeleteTagsConfirmation = (tagIds) => {
        const tags = Array.isArray(tagIds) ? tagIds : [tagIds];
        const final_tag = tags.map((tag) => ({ tagId: tag }));
        this.setState({
            selectedDataTags: final_tag,
            showDataTagDeleteConfirmation: true,
            ismulti: true,
            deleteDataTagConfirmMessage: `Are you sure, you want to delete selected data tags?`,
        });
    };

    onMultiDeleteTagsConfirmed = () => {
        this.setState({
            busy: true,
            busyMessage: "Deleting data tags...",
        });
        this.props.multiDeleteDataTags(this.state.selectedDataTags);
        this.onDeleteDataTagCancel();
    };

    showDeleteDataTagConfirmation = (dataTag) => {
        this.setState({
            deletedDataTag: dataTag,
            showDataTagDeleteConfirmation: true,
            deleteDataTagConfirmMessage: `Are you sure, you want to delete '${dataTag.tagName}' data tag?`,
        });
    };

    onDeleteDataTagConfirmed = () => {
        this.setState({
            busy: true,
            busyMessage: "Deleting data tag...",
        });
        this.props.deleteDataTag(this.state.deletedDataTag.tagId);
        this.onDeleteDataTagCancel();
    };

    onDeleteDataTagCancel = () => {
        this.setState({
            deletedDataTag: null,
            showDataTagDeleteConfirmation: false,
            deleteDataTagConfirmMessage: "",
        });
    };
    handleViewChange = (newViewState) => {
        this.props.setViewState(newViewState);
        localStorage.setItem("viewState", newViewState);
    };

    isBusy = () => {
        let isBusy = this.state.busy || this.state.fetchingDataTags || this.state.fetchingPermission;
        if (this.props.action === "view" || this.props.action === "edit") {
            isBusy = isBusy || this.state.fetchingDataTag;
        }
        return isBusy;
    };

    onDataTagValuesChanged = (changedValues, allValues) => {
        if (_.isEmpty(this.state.manageDataTagErrors) === false) {
            let manageDataTagErrors = { ...this.state.manageDataTagErrors };
            let flatObject = flatten(changedValues);
            for (let key in flatObject) {
                delete manageDataTagErrors[key];
            }
            this.setState({
                manageDataTagErrors,
            });
        }
    };

    getDataTagComponent = () => {
        if (this.state.permissionDenied) {
            return <ProhibitedArea></ProhibitedArea>;
        }
        if (!this.props.action) {
            return (
                <>
                    <OkCancelConfirmationBox
                        show={this.state.showDataTagDeleteConfirmation}
                        message={this.state.deleteDataTagConfirmMessage}
                        onCancel={this.onDeleteDataTagCancel}
                        onOk={this.state.ismulti ? this.onMultiDeleteTagsConfirmed : this.onDeleteDataTagConfirmed}
                    ></OkCancelConfirmationBox>
                    {!this.state.fetchingDataTags ? (
                        <DataTagList
                            dataTagList={this.props.dataTagsResult.Items}
                            onCreateNewDataTag={this.showCreateDataTag}
                            onEditDataTag={this.showEditDataTag}
                            onDeleteDataTag={this.showDeleteDataTagConfirmation}
                            onMultiDeleteDataTags={this.showMultiDeleteTagsConfirmation}
                            onBulkMoveDataTags={this.bulkMoveDataTags}
                            onViewDataTag={this.showViewDataTag}
                            onViewDataTagHistory={this.showDataTagHistory}
                            onTagReorder={this.handleTagReorder}
                            permission={this.props.permission}
                            viewState={this.props.viewState}
                            onViewChange={this.handleViewChange}
                            generateTagsWithAI={this.aiGenerateDataTag}
                            createTags={this.bulkCreateDataTag}
                            rephraseDataTag={this.rephraseDataTag}
                            isGeneratingTags={this.state.isGeneratingTags}
                            isCreatingTags={this.state.isCreatingTags}
                            isRephrasingTags={this.state.isRephrasingTags}
                            rephrasedDataTag={this.props.rephrasedDataTag}
                            aiGeneratedTags={this.props.aiGeneratedTags}
                            resetAiGeneratedTags={this.resetGeneratedTags}
                            businessAreaList={this.props.businessAreaList}
                            openAIKeyExists={this.props.keyExists}
                            bulkCreateErrors={this.props.bulkCreateDataTagResult.success ? null : this.props.bulkCreateDataTagResult}
                            aiGeneratedErrors={this.props.aiGenerateDataTagResult.success ? null : this.props.aiGenerateDataTagResult}
                        ></DataTagList>
                    ) : (
                        <></>
                    )}
                </>
            );
        }
        switch (this.props.action) {
            case "create":
                return (
                    <ManageDataTag
                        action={this.props.action}
                        businessAreaList={this.props.businessAreaList}
                        createDataTag={this.createDataTag}
                        onCancel={this.cancelManageDataTag}
                        formErrors={this.state.manageDataTagErrors}
                        onValuesChanged={this.onDataTagValuesChanged}
                        permission={this.props.permission}
                        activeBusinessAreaId={this.props.activeBusinessAreaId}
                        generateTagsWithAI={this.aiGenerateDataTag}
                        generateDescriptionWithAI={this.aiGenerateDescription}
                        createTags={this.bulkCreateDataTag}
                        rephraseDataTag={this.rephraseDataTag}
                        isGeneratingTags={this.state.isGeneratingTags}
                        isCreatingTags={this.state.isCreatingTags}
                        isRephrasingTags={this.state.isRephrasingTags}
                        rephrasedDataTag={this.props.rephrasedDataTag}
                        aiGeneratedTags={this.props.aiGeneratedTags}
                        aiDescription={this.props.aiDescription}
                        resetAiGeneratedTags={this.resetGeneratedTags}
                        bulkCreateErrors={this.props.bulkCreateDataTagResult.success ? null : this.props.bulkCreateDataTagResult}
                        aiGeneratedErrors={this.props.aiGenerateDataTagResult.success ? null : this.props.aiGenerateDataTagResult}
                        openAIKeyExists={this.props.keyExists}
                    ></ManageDataTag>
                );
            case "view":
            case "edit":
                return !this.state.fetchingDataTag ? (
                    this.props.dataTag ? (
                        <ManageDataTag
                            action={this.props.action}
                            dataTag={this.props.dataTag}
                            businessAreaList={this.props.businessAreaList}
                            onCancel={this.cancelManageDataTag}
                            updateDataTag={this.updateDataTag}
                            formErrors={this.state.manageDataTagErrors}
                            onValuesChanged={this.onDataTagValuesChanged}
                            permission={this.props.permission}
                        ></ManageDataTag>
                    ) : this.props.getDataTagByIdResult.success ? (
                        <MessageBox floating size="big" header="Data Tag not found.">
                            <p>The Data Tag you are looking for does not exist.</p>
                        </MessageBox>
                    ) : (
                        <></>
                    )
                ) : (
                    <></>
                );
            case "history":
                return this.state.showHistory ? <DataTagAudit dataTag={this.props.dataTag} onClose={this.cancelManageDataTag}></DataTagAudit> : <></>;
            default:
                return <ProhibitedArea></ProhibitedArea>;
        }
    };

    render() {
        return (
            <>
                <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                {!this.state.fetchingPermission ? this.getDataTagComponent() : <></>}
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        businessAreaList: state.home.businessAreas,
        getUserBusinessAreasResult: state.home.getUserBusinessAreasResult,
        dataTagsResult: state.dataTags.dataTagsResult,
        getDataTagsResult: state.dataTags.getDataTagsResult,
        createDataTagResult: state.dataTags.createDataTagResult,
        getDataTagByIdResult: state.dataTags.getDataTagByIdResult,
        dataTag: state.dataTags.dataTag,
        updateDataTagResult: state.dataTags.updateDataTagResult,
        bulkUpdateDataTagResult: state.dataTags.bulkUpdateDataTagResult,
        deleteDataTagResult: state.dataTags.deleteDataTagResult,
        getUserDataTagPermissionResult: state.dataTags.getUserDataTagPermissionResult,
        permission: state.dataTags.permission,
        isUpdating: state.dataTags.isUpdating,
        reorderResult: state.dataTags.reorderDataTagsResult,
        viewState: state.dataTags.ViewState,
        multiDeleteDataTagsResult: state.dataTags.multiDeleteDataTagsResult,
        bulkCreateDataTagResult: state.dataTags.bulkCreateDataTagResult,
        aiGenerateDataTagResult: state.dataTags.aiGenerateDataTagResult,
        aiGeneratedTags: state.dataTags.aiDataTagsResult,
        keyExists: state.systemKeys.keyExists,
        getKeyByTypeExistsResult: state.systemKeys.getKeyByTypeExistsResult,
        checkedKeys: state.systemKeys.checkedKeys,
        rephraseDataTagResult: state.dataTags.rephraseDataTagResult,
        rephrasedDataTag: state.dataTags.rephrasedDataTag,
        activeBusinessAreaId: state.home.activeBusinessAreaId,
        aiGenerateDescriptionResult: state.dataTags.aiGenerateDescriptionResult,
        aiDescription: state.dataTags.aiDescription,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserBusinessAreas: () => dispatch(actions.getUserBusinessAreasRequest()),
        getDataTags: () => dispatch(actions.getDataTagsRequest()),
        createDataTag: (dataTag) => dispatch(actions.createDataTagRequest(dataTag)),
        getDataTagById: (tagId) => dispatch(actions.getDataTagByIdRequest(tagId)),
        updateDataTag: (dataTag, updatedDataTag) => dispatch(actions.updateDataTagRequest(dataTag, updatedDataTag)),
        bulkUpdateDataTag: (dataTags) => dispatch(actions.bulkUpdateDataTagRequest(dataTags)),
        deleteDataTag: (tagId) => dispatch(actions.deleteDataTagRequest(tagId)),
        getUserDataTagPermission: () => dispatch(actions.getUserDataTagPermissionRequest()),
        reorderDataTags: (dataTags) => dispatch(actions.reorderDataTagsRequest(dataTags)),
        dndTags: (datatag) => dispatch(actions.dndTag(datatag)),
        setViewState: (viewState) => dispatch(actions.setViewState(viewState)),
        multiDeleteDataTags: (tagIds) => dispatch(actions.multiDeleteDataTagsRequest(tagIds)),
        bulkCreateDataTag: (dataTag) => dispatch(actions.bulkCreateDataTagRequest(dataTag)),
        aiGenerateDataTag: (dataTag) => dispatch(actions.aiGenerateDataTagRequest(dataTag)),
        resetAiGeneratedTags: () => dispatch(actions.resetAiGeneratedTags()),
        getKeyByTypeExists: (keyType) => dispatch(actions.getKeyByTypeExistsRequest(keyType)),
        rephraseDataTag: (dataTag) => dispatch(actions.rephraseDataTagRequest(dataTag)),
        aiGenerateDescription: (dataTag) => dispatch(actions.aiGenerateDescriptionRequest(dataTag)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataTags));
